import { Injectable } from '@angular/core';
import { StorageService } from '../_services';

@Injectable({
  providedIn: 'root'
})
export class UserSettingsService {
  // currentUser: any;

  constructor(
    private storageService: StorageService
  ) {
    // this.currentUser = this.storageService.getItem('SignIn');
  }

  getActualRole(currentUser) {

    //Is Rol 9 Both
    if (currentUser.UserDetails.UserTypeID === 9) {
      if (!currentUser.switchUserprofile) {
        localStorage.setItem('rol', 'Seller');
        return 'Seller';
      } else if (currentUser.switchUserprofile) {
        localStorage.setItem('rol', 'Buyer');
        return 'Buyer';
      } else {
        localStorage.setItem('rol', 'Unknown rol - Switch Option');
        return 'Unknown rol - Switch Option';
      }
    } else {
      if ([8, 10].indexOf(currentUser.UserDetails.UserTypeID) != -1) {
        localStorage.setItem('rol', 'Seller');
        return 'Seller'
      } else if ([5, 11].indexOf(currentUser.UserDetails.UserTypeID) != -1) {
        localStorage.setItem('rol', 'Buyer');
        return 'Buyer'
      } else {
        localStorage.setItem('rol', 'Unknown rol');
        return 'Unknown rol'
      }
    }

  }
}